// ajax fetch for ds net
// @author CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @create 2020/08/28 16:53
import { serialize, json2FormData, keepProps } from '../utils';
import { ResponseError } from '../utils/response-error';
const defaultConfig = {
    fetchError: '[FetchError] Request failed!',
    parseError: '[ParseError] Data parsing failed!',
};
/**
 * ajax fetch method
 * @param api 接口 URL
 * @param options 请求参数
 * @param resHandler 返回的数据处理，如果不传，默认按 ajax 方式处理
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
 */
export async function fetcher(api, options = {}, resHandler) {
    var _a;
    options = Object.assign({ method: options.method || 'GET', headers: options.headers || {}, responseType: 'json' }, options);
    const { data, payload, search = {}, dataType, serializeOptions = {}, fetchErrorMessage } = options;
    // 保留 window.fetch 需要的参数
    const fetchOption = keepProps(options, [
        'body',
        'cache',
        'credentials',
        'headers',
        'integrity',
        'keepalive',
        'method',
        'mode',
        'redirect',
        'referrer',
        'referrerPolicy',
        'signal',
    ]);
    // POST, PUT, PATCH
    const isSender = ['POST', 'PUT', 'PATCH'].includes((_a = options.method) === null || _a === void 0 ? void 0 : _a.toUpperCase());
    const searchParams = Object.assign(Object.assign({}, search), ((!isSender || payload) && typeof data === 'object' ? data : {}));
    // PUT, POST, PATCH
    if (isSender) {
        let sendData = payload || data;
        let isFormData = sendData instanceof FormData;
        const isPureData = sendData instanceof Blob || sendData instanceof ArrayBuffer;
        fetchOption.headers = Object.assign({}, options.headers);
        // 手动将 json 转换为 formData
        if (dataType === 'formData' && !isFormData) {
            sendData = json2FormData(sendData);
            isFormData = true;
        }
        if (isPureData || typeof sendData === 'string') {
            fetchOption.body = sendData;
        }
        else if (isFormData) {
            fetchOption.body = sendData;
            // formData 不能手动指定 content-type，否则在遇到文件上传场景时会报错
            // fetchOption.headers['Content-Type'] = 'multipart/form-data';
        }
        else {
            fetchOption.body = JSON.stringify(sendData);
            fetchOption.headers['Content-Type'] = 'application/json;charset=utf-8';
        }
    }
    else if (payload) {
        // 就算是非 post/put 请求，也可以强行传入 payload，但这里不会主动修改 content-type
        fetchOption.body = (typeof payload === 'string' ? payload : JSON.stringify(payload));
    }
    const connector = api.indexOf('?') > 0 ? '&' : '?';
    const url = `${api}${connector}${serialize(searchParams, serializeOptions)}`;
    const res = await window.fetch(url, fetchOption).catch((error) => {
        console.warn('ERROR in fetch: ', error);
        throw new ResponseError(fetchErrorMessage || defaultConfig.fetchError, -1, {});
    });
    if (res.status < 200 || res.status > 399) {
        throw new ResponseError(res.statusText || `Fetch Error: ${res.status}`, res.status, res);
    }
    // 如果有自定义的处理方式，则直接调用
    if (typeof resHandler === 'function') {
        return resHandler(res, options);
    }
    return await res[options.responseType]().catch((error) => {
        console.warn(`ERROR in res.${options.responseType}(): `, error);
        throw new ResponseError(fetchErrorMessage || defaultConfig.parseError, res.redirected ? 302 : res.status, res);
    });
}
